import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getCostCenterNumbers({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_COST_CENTER_NUMBERS_REQUEST')

        return axios
            .get(`/finances/finances/cost-center-numbers${paginate}${query}`)
            .then((response) => {
                commit('GET_COST_CENTER_NUMBERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch((error) => {
                commit('GET_COST_CENTER_NUMBERS_FAILURE')
                handleApiError(error, 'Pobranie listy MPK nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createCostCenterNumber(context, payload) {
        return axios
            .post('/finances/finances/cost-center-numbers', payload)
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                handleApiError(error, 'Dodanie MPK nie powiodło się.')

                return Promise.reject(error)
            })
    },

    updateCostCenterNumber(context, payload) {
        return axios
            .patch(`/finances/finances/cost-center-numbers/${payload.id}`, payload)
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                handleApiError(error, 'Edycja MPK nie powiodła się.')

                return Promise.reject(error)
            })
    },

    syncCostCenterNumbers() {
        return axios
            .post('/finances/finances/cost-center-numbers-sync')
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                handleApiError(error, 'Nie udało się zsynchronizować kodów MPK')

                return Promise.reject(error)
            })
    },
}
